import { Icon } from '@chakra-ui/react';

const CollaboratorsIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props} fill="none">
    <g id="CollaboratorsIcon">
<path d="M12.5 8.5H15.5" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14 7V10" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M6.75 10C8.82107 10 10.5 8.32107 10.5 6.25C10.5 4.17893 8.82107 2.5 6.75 2.5C4.67893 2.5 3 4.17893 3 6.25C3 8.32107 4.67893 10 6.75 10Z" stroke="#8D8186" strokeMiterlimit="10"/>
<path d="M1.3877 12.5C2.04473 11.7169 2.8653 11.0872 3.79173 10.6552C4.71817 10.2232 5.72798 9.99928 6.7502 9.99928C7.77241 9.99928 8.78222 10.2232 9.70866 10.6552C10.6351 11.0872 11.4557 11.7169 12.1127 12.5" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  </Icon>
);


/**
 *
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
</svg>
 *
 */

export default CollaboratorsIcon;
